/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ClockCommunicationRequest } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { SendPunchingZoneRequest } from '../api-models';
// @ts-ignore
import { TechIdRequest } from '../api-models';
// @ts-ignore
import { TimeClockGroupResponse } from '../api-models';
/**
 * TimeClockApi - axios parameter creator
 * @export
 */
export const TimeClockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Removes all employee records from the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockCleanEmployeesPost: async (clockCommunicationRequest?: ClockCommunicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/cleanEmployees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clockCommunicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends configuration data to the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockConfigureClocksPost: async (clockCommunicationRequest?: ClockCommunicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/configureClocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clockCommunicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves configuration data from the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockGetClockConfigurationsPost: async (clockCommunicationRequest?: ClockCommunicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/getClockConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clockCommunicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the current status from the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockGetClockStatusPost: async (clockCommunicationRequest?: ClockCommunicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/getClockStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clockCommunicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves employee records currently stored on the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockGetEmployeesPost: async (clockCommunicationRequest?: ClockCommunicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/getEmployees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clockCommunicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all time clock groups and their associated time clock devices stored in the  facility database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockGroupsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes a technician clock ID from the specified time clock devices.
         * @param {TechIdRequest} [techIdRequest] Body containing the target device primary keys and the technician clock ID to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockRemoveTechIdPost: async (techIdRequest?: TechIdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/removeTechId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(techIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pushes employee data to the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSendEmployeesPost: async (clockCommunicationRequest?: ClockCommunicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/sendEmployees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clockCommunicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transmits punching zone data to the specified time clock devices.
         * @param {SendPunchingZoneRequest} [sendPunchingZoneRequest] Body containing the target device primary keys and whether to send only updated  zones or all zones.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSendPunchingZonesPost: async (sendPunchingZoneRequest?: SendPunchingZoneRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/sendPunchingZones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPunchingZoneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a technician clock ID to the specified time clock devices.
         * @param {TechIdRequest} [techIdRequest] Body containing the target device primary keys and the technician clock ID to send.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSendTechIdPost: async (techIdRequest?: TechIdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/sendTechId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(techIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Instructs the specified time clock devices to obtain the correct time from a time  server and set it on the hardware.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSetClockTimePost: async (clockCommunicationRequest?: ClockCommunicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/setClockTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clockCommunicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Synchronises employee records to the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSynchEmployeesPost: async (clockCommunicationRequest?: ClockCommunicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/timeclock/synchEmployees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clockCommunicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeClockApi - functional programming interface
 * @export
 */
export const TimeClockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeClockApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Removes all employee records from the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockCleanEmployeesPost(clockCommunicationRequest?: ClockCommunicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockCleanEmployeesPost(clockCommunicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends configuration data to the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockConfigureClocksPost(clockCommunicationRequest?: ClockCommunicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockConfigureClocksPost(clockCommunicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves configuration data from the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockGetClockConfigurationsPost(clockCommunicationRequest?: ClockCommunicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockGetClockConfigurationsPost(clockCommunicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves the current status from the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockGetClockStatusPost(clockCommunicationRequest?: ClockCommunicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockGetClockStatusPost(clockCommunicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves employee records currently stored on the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockGetEmployeesPost(clockCommunicationRequest?: ClockCommunicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockGetEmployeesPost(clockCommunicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all time clock groups and their associated time clock devices stored in the  facility database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockGroupsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeClockGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockGroupsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes a technician clock ID from the specified time clock devices.
         * @param {TechIdRequest} [techIdRequest] Body containing the target device primary keys and the technician clock ID to remove.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockRemoveTechIdPost(techIdRequest?: TechIdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockRemoveTechIdPost(techIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Pushes employee data to the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockSendEmployeesPost(clockCommunicationRequest?: ClockCommunicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockSendEmployeesPost(clockCommunicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Transmits punching zone data to the specified time clock devices.
         * @param {SendPunchingZoneRequest} [sendPunchingZoneRequest] Body containing the target device primary keys and whether to send only updated  zones or all zones.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockSendPunchingZonesPost(sendPunchingZoneRequest?: SendPunchingZoneRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockSendPunchingZonesPost(sendPunchingZoneRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends a technician clock ID to the specified time clock devices.
         * @param {TechIdRequest} [techIdRequest] Body containing the target device primary keys and the technician clock ID to send.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockSendTechIdPost(techIdRequest?: TechIdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockSendTechIdPost(techIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Instructs the specified time clock devices to obtain the correct time from a time  server and set it on the hardware.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockSetClockTimePost(clockCommunicationRequest?: ClockCommunicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockSetClockTimePost(clockCommunicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Synchronises employee records to the specified time clock devices.
         * @param {ClockCommunicationRequest} [clockCommunicationRequest] Body containing the primary keys of the time clock devices to target.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeclockSynchEmployeesPost(clockCommunicationRequest?: ClockCommunicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TimeclockSynchEmployeesPost(clockCommunicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TimeClockApi - factory interface
 * @export
 */
export const TimeClockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeClockApiFp(configuration)
    return {
        /**
         * 
         * @summary Removes all employee records from the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockCleanEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockCleanEmployeesPost(requestParameters: TimeClockApiApiV2TimeclockCleanEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockCleanEmployeesPost(requestParameters.clockCommunicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends configuration data to the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockConfigureClocksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockConfigureClocksPost(requestParameters: TimeClockApiApiV2TimeclockConfigureClocksPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockConfigureClocksPost(requestParameters.clockCommunicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves configuration data from the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockGetClockConfigurationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockGetClockConfigurationsPost(requestParameters: TimeClockApiApiV2TimeclockGetClockConfigurationsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockGetClockConfigurationsPost(requestParameters.clockCommunicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the current status from the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockGetClockStatusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockGetClockStatusPost(requestParameters: TimeClockApiApiV2TimeclockGetClockStatusPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockGetClockStatusPost(requestParameters.clockCommunicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves employee records currently stored on the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockGetEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockGetEmployeesPost(requestParameters: TimeClockApiApiV2TimeclockGetEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockGetEmployeesPost(requestParameters.clockCommunicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all time clock groups and their associated time clock devices stored in the  facility database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockGroupsGet(options?: AxiosRequestConfig): AxiosPromise<Array<TimeClockGroupResponse>> {
            return localVarFp.apiV2TimeclockGroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes a technician clock ID from the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockRemoveTechIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockRemoveTechIdPost(requestParameters: TimeClockApiApiV2TimeclockRemoveTechIdPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockRemoveTechIdPost(requestParameters.techIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pushes employee data to the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockSendEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSendEmployeesPost(requestParameters: TimeClockApiApiV2TimeclockSendEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockSendEmployeesPost(requestParameters.clockCommunicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transmits punching zone data to the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockSendPunchingZonesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSendPunchingZonesPost(requestParameters: TimeClockApiApiV2TimeclockSendPunchingZonesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockSendPunchingZonesPost(requestParameters.sendPunchingZoneRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a technician clock ID to the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockSendTechIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSendTechIdPost(requestParameters: TimeClockApiApiV2TimeclockSendTechIdPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockSendTechIdPost(requestParameters.techIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Instructs the specified time clock devices to obtain the correct time from a time  server and set it on the hardware.
         * @param {TimeClockApiApiV2TimeclockSetClockTimePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSetClockTimePost(requestParameters: TimeClockApiApiV2TimeclockSetClockTimePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockSetClockTimePost(requestParameters.clockCommunicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Synchronises employee records to the specified time clock devices.
         * @param {TimeClockApiApiV2TimeclockSynchEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeclockSynchEmployeesPost(requestParameters: TimeClockApiApiV2TimeclockSynchEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2TimeclockSynchEmployeesPost(requestParameters.clockCommunicationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2TimeclockCleanEmployeesPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockCleanEmployeesPostRequest
 */
export interface TimeClockApiApiV2TimeclockCleanEmployeesPostRequest {
    /**
     * Body containing the primary keys of the time clock devices to target.
     * @type {ClockCommunicationRequest}
     * @memberof TimeClockApiApiV2TimeclockCleanEmployeesPost
     */
    readonly clockCommunicationRequest?: ClockCommunicationRequest
}

/**
 * Request parameters for apiV2TimeclockConfigureClocksPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockConfigureClocksPostRequest
 */
export interface TimeClockApiApiV2TimeclockConfigureClocksPostRequest {
    /**
     * Body containing the primary keys of the time clock devices to target.
     * @type {ClockCommunicationRequest}
     * @memberof TimeClockApiApiV2TimeclockConfigureClocksPost
     */
    readonly clockCommunicationRequest?: ClockCommunicationRequest
}

/**
 * Request parameters for apiV2TimeclockGetClockConfigurationsPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockGetClockConfigurationsPostRequest
 */
export interface TimeClockApiApiV2TimeclockGetClockConfigurationsPostRequest {
    /**
     * Body containing the primary keys of the time clock devices to target.
     * @type {ClockCommunicationRequest}
     * @memberof TimeClockApiApiV2TimeclockGetClockConfigurationsPost
     */
    readonly clockCommunicationRequest?: ClockCommunicationRequest
}

/**
 * Request parameters for apiV2TimeclockGetClockStatusPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockGetClockStatusPostRequest
 */
export interface TimeClockApiApiV2TimeclockGetClockStatusPostRequest {
    /**
     * Body containing the primary keys of the time clock devices to target.
     * @type {ClockCommunicationRequest}
     * @memberof TimeClockApiApiV2TimeclockGetClockStatusPost
     */
    readonly clockCommunicationRequest?: ClockCommunicationRequest
}

/**
 * Request parameters for apiV2TimeclockGetEmployeesPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockGetEmployeesPostRequest
 */
export interface TimeClockApiApiV2TimeclockGetEmployeesPostRequest {
    /**
     * Body containing the primary keys of the time clock devices to target.
     * @type {ClockCommunicationRequest}
     * @memberof TimeClockApiApiV2TimeclockGetEmployeesPost
     */
    readonly clockCommunicationRequest?: ClockCommunicationRequest
}

/**
 * Request parameters for apiV2TimeclockRemoveTechIdPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockRemoveTechIdPostRequest
 */
export interface TimeClockApiApiV2TimeclockRemoveTechIdPostRequest {
    /**
     * Body containing the target device primary keys and the technician clock ID to remove.
     * @type {TechIdRequest}
     * @memberof TimeClockApiApiV2TimeclockRemoveTechIdPost
     */
    readonly techIdRequest?: TechIdRequest
}

/**
 * Request parameters for apiV2TimeclockSendEmployeesPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockSendEmployeesPostRequest
 */
export interface TimeClockApiApiV2TimeclockSendEmployeesPostRequest {
    /**
     * Body containing the primary keys of the time clock devices to target.
     * @type {ClockCommunicationRequest}
     * @memberof TimeClockApiApiV2TimeclockSendEmployeesPost
     */
    readonly clockCommunicationRequest?: ClockCommunicationRequest
}

/**
 * Request parameters for apiV2TimeclockSendPunchingZonesPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockSendPunchingZonesPostRequest
 */
export interface TimeClockApiApiV2TimeclockSendPunchingZonesPostRequest {
    /**
     * Body containing the target device primary keys and whether to send only updated  zones or all zones.
     * @type {SendPunchingZoneRequest}
     * @memberof TimeClockApiApiV2TimeclockSendPunchingZonesPost
     */
    readonly sendPunchingZoneRequest?: SendPunchingZoneRequest
}

/**
 * Request parameters for apiV2TimeclockSendTechIdPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockSendTechIdPostRequest
 */
export interface TimeClockApiApiV2TimeclockSendTechIdPostRequest {
    /**
     * Body containing the target device primary keys and the technician clock ID to send.
     * @type {TechIdRequest}
     * @memberof TimeClockApiApiV2TimeclockSendTechIdPost
     */
    readonly techIdRequest?: TechIdRequest
}

/**
 * Request parameters for apiV2TimeclockSetClockTimePost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockSetClockTimePostRequest
 */
export interface TimeClockApiApiV2TimeclockSetClockTimePostRequest {
    /**
     * Body containing the primary keys of the time clock devices to target.
     * @type {ClockCommunicationRequest}
     * @memberof TimeClockApiApiV2TimeclockSetClockTimePost
     */
    readonly clockCommunicationRequest?: ClockCommunicationRequest
}

/**
 * Request parameters for apiV2TimeclockSynchEmployeesPost operation in TimeClockApi.
 * @export
 * @interface TimeClockApiApiV2TimeclockSynchEmployeesPostRequest
 */
export interface TimeClockApiApiV2TimeclockSynchEmployeesPostRequest {
    /**
     * Body containing the primary keys of the time clock devices to target.
     * @type {ClockCommunicationRequest}
     * @memberof TimeClockApiApiV2TimeclockSynchEmployeesPost
     */
    readonly clockCommunicationRequest?: ClockCommunicationRequest
}

/**
 * TimeClockApi - object-oriented interface
 * @export
 * @class TimeClockApi
 * @extends {BaseAPI}
 */
export class TimeClockApi extends BaseAPI {
    /**
     * 
     * @summary Removes all employee records from the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockCleanEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockCleanEmployeesPost(requestParameters: TimeClockApiApiV2TimeclockCleanEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockCleanEmployeesPost(requestParameters.clockCommunicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends configuration data to the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockConfigureClocksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockConfigureClocksPost(requestParameters: TimeClockApiApiV2TimeclockConfigureClocksPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockConfigureClocksPost(requestParameters.clockCommunicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves configuration data from the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockGetClockConfigurationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockGetClockConfigurationsPost(requestParameters: TimeClockApiApiV2TimeclockGetClockConfigurationsPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockGetClockConfigurationsPost(requestParameters.clockCommunicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the current status from the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockGetClockStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockGetClockStatusPost(requestParameters: TimeClockApiApiV2TimeclockGetClockStatusPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockGetClockStatusPost(requestParameters.clockCommunicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves employee records currently stored on the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockGetEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockGetEmployeesPost(requestParameters: TimeClockApiApiV2TimeclockGetEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockGetEmployeesPost(requestParameters.clockCommunicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all time clock groups and their associated time clock devices stored in the  facility database.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockGroupsGet(options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockGroupsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes a technician clock ID from the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockRemoveTechIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockRemoveTechIdPost(requestParameters: TimeClockApiApiV2TimeclockRemoveTechIdPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockRemoveTechIdPost(requestParameters.techIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pushes employee data to the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockSendEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockSendEmployeesPost(requestParameters: TimeClockApiApiV2TimeclockSendEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockSendEmployeesPost(requestParameters.clockCommunicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transmits punching zone data to the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockSendPunchingZonesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockSendPunchingZonesPost(requestParameters: TimeClockApiApiV2TimeclockSendPunchingZonesPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockSendPunchingZonesPost(requestParameters.sendPunchingZoneRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a technician clock ID to the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockSendTechIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockSendTechIdPost(requestParameters: TimeClockApiApiV2TimeclockSendTechIdPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockSendTechIdPost(requestParameters.techIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Instructs the specified time clock devices to obtain the correct time from a time  server and set it on the hardware.
     * @param {TimeClockApiApiV2TimeclockSetClockTimePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockSetClockTimePost(requestParameters: TimeClockApiApiV2TimeclockSetClockTimePostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockSetClockTimePost(requestParameters.clockCommunicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Synchronises employee records to the specified time clock devices.
     * @param {TimeClockApiApiV2TimeclockSynchEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeClockApi
     */
    public apiV2TimeclockSynchEmployeesPost(requestParameters: TimeClockApiApiV2TimeclockSynchEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return TimeClockApiFp(this.configuration).apiV2TimeclockSynchEmployeesPost(requestParameters.clockCommunicationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
